import { SnailIcon } from './SnailIcon';

/**
 * author: Colton Wiscombe
 * id 529CCAF2-D35F-4A40-BEF2-213159AE5DD9
 * name snail
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/snail.svg
 * tags
 * - Animal 
 */
export const GastropodIcon = SnailIcon;
export default GastropodIcon